import { StyledTooltip } from './Tooltip.styles';

export default StyledTooltip;
